import {  Col, Row } from 'reactstrap';
import { SmallWidgetsData } from './analyticsData';
import SmallWidgets from './gridCardLayout';

const GridCards = () => {
  return (
    <Col xxl='5' md='10' className='box-col-7'>
      <Row>
        {SmallWidgetsData.map((data, i) => (
          <Col xs='6' key={`widget-${data.title}-${i}`}>
            <SmallWidgets data={data} />
          </Col>
        ))}
      </Row>
    </Col>
  );
};

export default GridCards;
